module.exports = __webpack_public_path__ + "static/img/feature_4.c4823a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/feature_4.png
// module id = aOvY
// module chunks = 0